import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "md:px-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-xs text-white! text-center"
}
const _hoisted_3 = {
  key: 1,
  class: "text-[10px] text-white! font-bold text-center"
}

export function render(_ctx, _cache) {
  const _component_PopupMainNavbar = _resolveComponent("PopupMainNavbar")
  const _component_PopupAffiliateNavbar = _resolveComponent("PopupAffiliateNavbar")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PopupMainNavbar),
    _createVNode(_component_PopupAffiliateNavbar),
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-xl text-white text-start font-extrabold my-3" }, "ประวัติแนะนำเพื่อน", -1 /* HOISTED */)),
      _createVNode(_component_Card, { pt: {root:'overflow-hidden! bg-[#000000cf]! border-2! border-[#24fba6]!', body: 'px-2!'} }, {
        content: _withCtx(() => [
          _createVNode(_component_DataTable, {
            value: _ctx.transaction.records,
            loading: _ctx.tableLoading,
            scrollable: "",
            scrollHeight: "400px",
            tableStyle: "min-width: 30rem;",
            size: "small",
            class: "table-auto w-full",
            pt: {
						root: 'min-h-[250px]',
						tableContainer: 'min-h-[300px] border-[#24fba6]!',
						thead: 'bg-[#12a368d4]!',
						tbody: 'bg-transparent!',
						bodyRow: 'bg-transparent! border-0!',
						emptyMessage: 'bg-transparent!'
					}
          }, {
            empty: _withCtx(() => [
              (_ctx.tableLoading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, "กำลังโหลดข้อมูล"))
                : (_openBlock(), _createElementBlock("p", _hoisted_3, "ไม่พบข้อมูล"))
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "wallet",
                header: "รูปแบบ",
                "header-class": "text-xs text-white!",
                "body-class": "text-xs text-white!",
                pt: {headerCell:'bg-transparent! text-white!'}
              }),
              _createVNode(_component_Column, {
                field: "transactionChannel",
                header: "ประเภท",
                "header-class": "text-xs text-white!",
                "body-class": "text-xs text-white!",
                pt: {headerCell:'bg-transparent! text-white!'}
              }),
              _createVNode(_component_Column, {
                field: "amount",
                header: "จำนวน",
                "header-class": "text-xs text-white!",
                "body-class": "text-xs text-white!",
                pt: {headerCell:'bg-transparent! text-white!'}
              }, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.formatCurrency(slotProps.data.amount)), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_Column, {
                field: "date",
                header: "วันที่",
                sortable: "",
                "header-class": "text-xs text-white!",
                "body-class": "text-xs text-white!",
                pt: {headerCell:'bg-transparent! text-white!'}
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["value", "loading"]),
          _createVNode(_component_Paginator, {
            first: _ctx.first,
            "onUpdate:first": _cache[0] || (_cache[0] = $event => ((_ctx.first) = $event)),
            rows: _ctx.rows,
            totalRecords: _ctx.totalRecords,
            template: "PrevPageLink CurrentPageReport NextPageLink",
            currentPageReportTemplate: "{first} ถึง {last} ทั้งหมด {totalRecords}",
            pt: { root: 'bg-[#12a368d4]! border-2! px-0! mt-5!', current: 'text-xs! text-white!', first: 'text-white!', last: 'text-white!', prev: 'text-white!', next: 'text-white!' }
          }, null, 8 /* PROPS */, ["first", "rows", "totalRecords"])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ], 64 /* STABLE_FRAGMENT */))
}